export default "__VITE_ASSET__a13492e1__"